import React, { useState, useEffect } from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { Link, useNavigate } from 'react-router-dom';
import './css/NavMenu.css'
import { useFirebaseAuth } from '../auth/FirebaseAuthProvider';
// @ts-ignore
import LogoSvg from './LogoSvg'

const NavMenu = () => {
    const [collapsed, setCollapsed] = useState<boolean>(true);
    const [userDropdownOpen, setUserDropdownOpen] = useState<boolean>(false);
    const toggleNavbar = () => setCollapsed(!collapsed);
    const toggleUserDropdown = () => setUserDropdownOpen(!userDropdownOpen);
    const { user, isAuthenticated, logout } = useFirebaseAuth();
    const navigate = useNavigate();

    const loggingIn = async () => navigate('/login');
    const loggingOut = async () => {
        await logout();
        navigate('/');
    };

    const isAdmin = user?.email === "sebastien.dubos@gmail.com";
    return (
        <header>
            <Navbar className="modern-navbar" expand="lg" fixed="top">
                <Container>
                    <NavbarBrand tag={Link} to="/" className="modern-brand">
                        <div className="brand-container">
                            {/* <div className="logo-container">
                                <LogoSvg className="brand-logo" />
                            </div> */}
                            <div className="brand-text">
                                <h4 className="brand-title">MyUnivers</h4>
                                <span className="brand-subtitle">Aviation & Smart Home</span>
                            </div>
                        </div>
                    </NavbarBrand>
                    
                    <NavbarToggler onClick={toggleNavbar} className="modern-toggler">
                        <span className="navbar-toggler-icon"></span>
                    </NavbarToggler>
                    
                    <Collapse isOpen={!collapsed} navbar>
                        <ul className="navbar-nav mx-auto">
                            <NavItem>
                                <NavLink tag={Link} className="modern-nav-link" to="/" onClick={() => setCollapsed(true)}>
                                    <i className="fas fa-home me-2"></i>
                                    Home
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink tag={Link} className="modern-nav-link" to="/LogBookAircraft" onClick={() => setCollapsed(true)}>
                                    <i className="fas fa-book me-2"></i>
                                    LogBook
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink tag={Link} className="modern-nav-link" to="/SmartHouse" onClick={() => setCollapsed(true)}>
                                    <i className="fas fa-home-alt me-2"></i>
                                    Smart House
                                </NavLink>
                            </NavItem>
                            {isAdmin && (
                                <NavItem>
                                    <NavLink tag={Link} className="modern-nav-link admin-link" to="/SmartHouseAdmin" onClick={() => setCollapsed(true)}>
                                        <i className="fas fa-cog me-2"></i>
                                        Admin
                                    </NavLink>
                                </NavItem>
                            )}
                        </ul>
                        
                        <div className="navbar-nav ms-auto">
                            {isAuthenticated ? (
                                <Dropdown nav isOpen={userDropdownOpen} toggle={toggleUserDropdown}>
                                    <DropdownToggle nav className="user-dropdown-toggle">
                                        <div className="user-info">
                                            <div className="user-avatar">
                                                <i className="fas fa-user-circle"></i>
                                            </div>
                                            <span className="user-email">{user?.email}</span>
                                            <i className="fas fa-chevron-down ms-2"></i>
                                        </div>
                                    </DropdownToggle>
                                    <DropdownMenu end className="user-dropdown-menu">
                                        <DropdownItem header className="user-dropdown-header">
                                            <div className="user-details">
                                                <div className="user-avatar-large">
                                                    <i className="fas fa-user-circle"></i>
                                                </div>
                                                <div className="user-text">
                                                    <strong>{user?.displayName || user?.email}</strong>
                                                    {isAdmin && <span className="admin-badge">Administrator</span>}
                                                </div>
                                            </div>
                                        </DropdownItem>
                                        <DropdownItem divider />
                                        <DropdownItem onClick={loggingOut} className="logout-item">
                                            <i className="fas fa-sign-out-alt me-2"></i>
                                            Logout
                                        </DropdownItem>
                                    </DropdownMenu>
                                </Dropdown>
                            ) : (
                                <NavItem>
                                    <button className="btn modern-login-btn" onClick={loggingIn}>
                                        <i className="fas fa-sign-in-alt me-2"></i>
                                        Login
                                    </button>
                                </NavItem>
                            )}
                        </div>
                    </Collapse>
                </Container>
            </Navbar>
        </header>
    );
}

export default NavMenu;
